export default function($document) {
    'ngInject';
    return {
      restrict: 'A',
      link: function($scope, $element, $attribute) {
          $element.bind('click', (event) => {
            event.stopPropagation();
          });
          $document.bind('click', () => {
            $scope.$apply($attribute.hideNoty);
          })
      }
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/menu/hide-notification.directive.js
 **/